import { createUseStyles } from '../../theme/theming';

const getArrowRotationAngle = (props) => {
  switch (true) {
    case props.left:
      return 180;
    case props.up:
      return 270;
    case props.down:
      return 90;
    case props.right:
    default:
      return 0;
  }
};

const sizeHandler = ({ size }) => (size === 'small' ? '32px' : '48px');
const useArrowButtonStyles = createUseStyles((theme) => ({
  arrowButtonContainer: {
    cursor: 'pointer',
    width: sizeHandler,
    height: sizeHandler,
    border: ({ inverted }) =>
      `solid 1px ${
        inverted
          ? theme?.palette?.font?.invertedDefault
          : theme?.colors?.AccentColor
      }`,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transform: (props) => `rotate(${getArrowRotationAngle(props)}deg)`,
    transition: 'all 0.7s'
  }
}));

export default useArrowButtonStyles;
